import { render, staticRenderFns } from "./ShipmentCertificateForm.vue?vue&type=template&id=4ee0d25c&scoped=true&"
import script from "./ShipmentCertificateForm.vue?vue&type=script&lang=ts&"
export * from "./ShipmentCertificateForm.vue?vue&type=script&lang=ts&"
import style0 from "./ShipmentCertificateForm.vue?vue&type=style&index=0&id=4ee0d25c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee0d25c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VBtn,VIcon,VSelect,VTextField,VTextarea})
